import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import {
  GET_DOCS_LIST,
  UPLOAD_DOC,
  DOWNLOAD_DOC,
  DELETE_DOC,
  GET_DOC_TYPE_LIST,
} from "../../../../Urls.js";

const initialState = {
  documentsList: { data: [], loading: false },
  uploadDocument: { data: {}, loading: false, successMessage: "" },
  downloadDocumentData: { data: {}, loading: false, successMessage: "" },
  deleteDocumentData: { data: [], loading: false, successMessage: "" },
  docTypeData: { data: [], loading: false },
  selectedAnnucementItem: {},
};

export const getDocTypeList = createAsyncThunk(
  "app/get/getDocTypeList",
  async () => {
    const response = await axios.get(GET_DOC_TYPE_LIST);
    return response;
  }
);
export const getDocumentsListusingAssetsId = createAsyncThunk(
  "app/get/getDocumentsList",
  async ({ assetsId, prefix }) => {
    const url = GET_DOCS_LIST + assetsId;
    const response = await axios.get(url, {
      params: prefix ? { prefix: prefix } : {},
    });
    return response;
  }
);

export const uploadDocument = createAsyncThunk(
  "app/get/uploadDocument",
  async ({ assetsId, file, destinationPath }) => {
    const formData = new FormData();
    formData.append("file", file);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    // Only add `params` if `destinationPath` exists
    if (destinationPath) {
      config.params = {
        destinationPath,
      };
    }

    const response = await axios.post(`${UPLOAD_DOC}${assetsId}`, formData, config);

    return response.data;
  }
);


export const downloadDocuments = createAsyncThunk(
  "app/get/downloadDocumentData",
  async ({ assetId, fileKey }, { rejectWithValue }) => {
    try {
      const encodedKey = encodeURIComponent(fileKey);
      const response = await axios.get(
        `${DOWNLOAD_DOC}${assetId}?fileKey=${encodedKey}`,
        {
          responseType: "blob",
        }
      );
      return {
        blob: response.data,
        fileKey,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Download failed");
    }
  }
);

export const deleteDocument = createAsyncThunk(
  "app/delete/deleteDocument",
  async ({ assetsId, fileKey }, { rejectWithValue }) => {
    try {
      const url = `${DELETE_DOC}${assetsId}`;
      const response = await axios.delete(url, {
        params: { fileKey },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Delete failed");
    }
  }
);

export const documentSlice = createSlice({
  name: "app/documentSlice",
  initialState,
  reducers: {
    selectedDocument: (state, action) => {
      state.selectedAnnucementItem = action?.payload;
    },
    clearSuccessMessage: (state) => {
      state.uploadDocument.successMessage = "";
      state.downloadDocumentData.successMessage = "";
      state.deleteDocumentData.successMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getDocTypeList.pending, (state) => {
        state.docTypeData.loader = true;
      })
      .addCase(getDocTypeList.fulfilled, (state, action) => {
        state.docTypeData.loader = false;
        state.docTypeData.data = action?.payload?.data?.data;
      })
      .addCase(getDocTypeList.rejected, (state) => {
        state.docTypeData.loader = false;
      })
      .addCase(getDocumentsListusingAssetsId.pending, (state) => {
        state.documentsList.loader = true;
      })
      .addCase(getDocumentsListusingAssetsId.fulfilled, (state, action) => {
        state.documentsList.loader = false;
        state.documentsList.data = action?.payload?.data?.data;
      })
      .addCase(getDocumentsListusingAssetsId.rejected, (state) => {
        state.documentsList.loader = false;
      })

      .addCase(uploadDocument.pending, (state) => {
        state.uploadDocument.loader = true;
      })
      .addCase(uploadDocument.fulfilled, (state, action) => {
        state.uploadDocument.loader = false;
        state.uploadDocument.data = action?.payload?.data?.data;
        state.uploadDocument.successMessage = "Document uploaded successfully!";
      })
      .addCase(uploadDocument.rejected, (state) => {
        state.uploadDocument.loader = false;
        state.uploadDocument.data = {};
        state.uploadDocument.successMessage = "Failed to upload document!";
      })
      .addCase(downloadDocuments.pending, (state) => {
        state.downloadDocumentData.loader = true;
      })
      .addCase(downloadDocuments.fulfilled, (state, action) => {
        state.downloadDocumentData.loader = false;
        state.downloadDocumentData.data = action?.payload?.data?.data;
        state.downloadDocumentData.successMessage =
          "Document downloaded successfully!";
      })
      .addCase(downloadDocuments.rejected, (state) => {
        state.downloadDocumentData.loader = false;
        state.downloadDocumentData.data = {};
        state.downloadDocumentData.successMessage =
          "Failed to downlaod document!";
      })
      .addCase(deleteDocument.pending, (state) => {
        state.deleteDocumentData.loading = true;
      })
      .addCase(deleteDocument.fulfilled, (state, action) => {
        state.deleteDocumentData.loading = false;
        state.deleteDocumentData.data = action?.payload?.data?.data;
        state.deleteDocumentData.successMessage =
          "Document deleted successfully!";
      })
      .addCase(deleteDocument.rejected, (state) => {
        state.deleteDocumentData.loading = false;
        state.deleteDocumentData.successMessage = "Failed to delete Document .";
      });
  },
});

export const { selectedDocument, clearSuccessMessage } = documentSlice.actions;

export default documentSlice.reducer;
